import { render } from "./MilestoneCumulativePage.vue?vue&type=template&id=1bc1dfd6"
import script from "./MilestoneCumulativePage.vue?vue&type=script&lang=js"
export * from "./MilestoneCumulativePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__